import React from 'react';
import { NoteType } from './Notes';
import { BaseSelectCheckbox } from 'shared-components/components/FormFields';
import { legacyOnChange } from 'shared-components/components/FormFields/ROSelectCheckbox/BaseSelectCheckbox';
import FilterListIcon from '@mui/icons-material/FilterList';

export interface NotesFilterProps {
  noteTypes: NoteType[];
  setFilterNoteTypes: any;
}

const NotesFilter = (props: NotesFilterProps): JSX.Element => {
  const { noteTypes, setFilterNoteTypes } = props;

  const updateNoteCheckBoxOptionTypes = (messageTypes: string[], checked: boolean): any => {
    const updateTypeFilter: NoteType[] | undefined = noteTypes?.map((item: NoteType) => {
      const updated = messageTypes?.filter((currentItem) => currentItem === item.id);
      if (updated.length) {
        item['checked'] = checked;
      }
      return item;
    });
    setFilterNoteTypes(updateTypeFilter || []);
  };

  const options = noteTypes.map((noteType) => {
    return {
      value: noteType.name,
      id: noteType.id,
      checked: noteType.checked || false,
    };
  });

  return (
    <BaseSelectCheckbox
      id="notes-filter"
      options={options}
      placeholder="Filter"
      displayEmpty
      IconComponent={FilterListIcon}
      MenuProps={{
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left',
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'left',
        },
      }}
      sx={{
        '& .MuiOutlinedInput-notchedOutline': {
          borderWidth: '1px',
          borderRadius: '6px',
          borderColor: 'text.secondary',
        },
        '& .MuiSelect-select': {
          display: 'flex',
          alignItems: 'center',
          fontWeight: 600,
          fontSize: '14px',
          letterSpacing: '0.5px',
          paddingTop: '4px !important',
          paddingBottom: '4px !important',
        },
        '& .MuiSelect-icon': {
          transform: 'none !important',
          paddingLeft: '2px',
          fontSize: '20px',
        },
        height: 'auto',
        minHeight: '32px',
      }}
      showSelectAll
      onChange={(event) => legacyOnChange(event, options, updateNoteCheckBoxOptionTypes)}
    />
  );
};

export default NotesFilter;
